import {
  ControlField,
  Group,
  Grouping,
  PropertyTemplates,
  Section,
  Template,
} from '../../../contexts/MetadataContext';

export interface PropertyTemplatesWithIds {
  [key: string]: TemplateWithIds;
}

export interface GroupWithId extends Omit<Group, 'sections'> {
  id: string;
  sections: SectionWithId[];
}

export interface GroupingWithId extends Grouping {
  id: string;
}

export interface SectionWithId extends Omit<Section, 'fields'> {
  id: string;
  fields: FieldWithId[];
}

export interface FieldWithId extends ControlField {
  id: string;
}

export interface TemplateWithIds extends Omit<
  Template,
  'groupings' | 'groups'
> {
  groups: GroupWithId[];
  groupings: GroupingWithId[];
  help?: Record<string, string>;
}

export const addIdsToTemplate = (
  template: PropertyTemplates,
): PropertyTemplatesWithIds => {
  const templatesWithIds: PropertyTemplatesWithIds = {};

  for (const [key, value] of Object.entries(template)) {
    templatesWithIds[key] = {
      ...value,
      groupings: (value.groupings || []).map((grouping: Grouping) => {
        return {
          ...grouping,
          id: crypto.randomUUID(),
        };
      }),
      groups: value.groups.map(
        (group: Group): GroupWithId => ({
          ...group,
          id: crypto.randomUUID(),
          sections: group.sections.map(
            (section: Section): SectionWithId => ({
              ...section,
              id: crypto.randomUUID(),
              fields: section.fields.map(
                (field: ControlField): FieldWithId => ({
                  ...field,
                  id: crypto.randomUUID(),
                }),
              ),
            }),
          ),
        }),
      ),
    };
  }

  return templatesWithIds;
};
